// import React, { useState, useEffect } from 'react';
// import { TrendingUp, Users, Package, AlertTriangle, Crown } from 'lucide-react';
// import { useFeatureAccess } from '../../hooks/useFeatureAccess';
// import apiClient from '../../api/client';
// import ABCChart from './Charts/ABCDistributionChart';
// import TrendLineChart from './Charts/TrendLineChart';
// import SegmentationChart from './Charts/SegmentationChart';
// import UpgradePrompt from '../subscription/UpgradePrompt';
// import './AnalyticsDashboard.css';

// function AnalyticsDashboard() {
//   const { hasFeature, getPlanName, loading: featureLoading } = useFeatureAccess();
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadAnalyticsSummary();
//   }, []);

//   async function loadAnalyticsSummary() {
//     try {
//       const response = await apiClient.get('/analytics/summary/');
//       setSummary(response.data);
//     } catch (error) {
//       console.error('Failed to load analytics:', error);
//     }
//     setLoading(false);
//   }

//   if (loading || featureLoading) {
//     return (
//       <div className="loading-screen">
//         <div className="spinner"></div>
//         <p>Loading analytics...</p>
//       </div>
//     );
//   }

//   if (!hasFeature('analytics_dashboard')) {
//     return (
//       <div className="analytics-locked">
//         <Crown size={48} />
//         <h2>Analytics Dashboard</h2>
//         <p>Upgrade to access AI-powered insights and analytics</p>
//         <UpgradePrompt feature="analytics_dashboard" />
//       </div>
//     );
//   }

//   return (
//     <div className="analytics-dashboard fade-in">
//       <div className="analytics-header">
//         <div>
//           <h1>Analytics & Insights</h1>
//           <p className="subtitle">AI-powered business intelligence</p>
//         </div>
//         <div className="plan-badge">
//           <Crown size={16} />
//           <span>{getPlanName().toUpperCase()} Plan</span>
//         </div>
//       </div>

//       <div className="metrics-grid">
//         <div className="metric-card">
//           <div className="metric-icon">
//             <Package size={24} />
//           </div>
//           <div className="metric-content">
//             <span className="metric-label">Total Products</span>
//             <span className="metric-value">{summary?.total_products || 0}</span>
//           </div>
//         </div>

//         <div className="metric-card success">
//           <div className="metric-icon">
//             <TrendingUp size={24} />
//           </div>
//           <div className="metric-content">
//             <span className="metric-label">Trending Up</span>
//             <span className="metric-value">{summary?.trending_up || 0}</span>
//           </div>
//         </div>

//         <div className="metric-card">
//           <div className="metric-icon">
//             <Users size={24} />
//           </div>
//           <div className="metric-content">
//             <span className="metric-label">Total Customers</span>
//             <span className="metric-value">{summary?.total_customers || 0}</span>
//           </div>
//         </div>

//         <div className="metric-card warning">
//           <div className="metric-icon">
//             <AlertTriangle size={24} />
//           </div>
//           <div className="metric-content">
//             <span className="metric-label">Anomaly Alerts</span>
//             <span className="metric-value">{summary?.new_alerts || 0}</span>
//           </div>
//         </div>
//       </div>

//       {/* ABC Classification Section */}
//       <div className="analytics-section">
//         <div className="section-header">
//           <h2>Product Classification (ABC Analysis)</h2>
//           <p>Products categorized by revenue contribution</p>
//         </div>

//         <div className="section-content">
//           <div className="classification-stats">
//             <div className="class-stat class-a">
//               <span className="class-label">Class A</span>
//               <span className="class-count">{summary?.class_a_products || 0}</span>
//               <span className="class-desc">High Value (80% revenue)</span>
//             </div>
//             <div className="class-stat class-b">
//               <span className="class-label">Class B</span>
//               <span className="class-count">{summary?.class_b_products || 0}</span>
//               <span className="class-desc">Medium Value (15% revenue)</span>
//             </div>
//             <div className="class-stat class-c">
//               <span className="class-label">Class C</span>
//               <span className="class-count">{summary?.class_c_products || 0}</span>
//               <span className="class-desc">Low Value (5% revenue)</span>
//             </div>
//           </div>

//           {hasFeature('advanced_charts') ? (
//             <ABCChart data={summary} />
//           ) : (
//             <UpgradePrompt 
//               feature="advanced_charts" 
//               message="Upgrade to Business plan for visual charts"
//             />
//           )}
//         </div>
//       </div>

//       {/* Top Products Section */}
//       <div className="analytics-section">
//         <div className="section-header">
//           <h2>Top Performing Products</h2>
//           <button onClick={() => window.location.href = '/analytics/products'} className="btn-link">
//             View All →
//           </button>
//         </div>

//         <div className="top-products-grid">
//           {summary?.top_products?.slice(0, 5).map(product => (
//             <div key={product.id} className="product-insight-card">
//               <div className="product-header">
//                 <h3>{product.product_name}</h3>
//                 <span className={`class-badge class-${product.classification.toLowerCase()}`}>
//                   Class {product.classification}
//                 </span>
//               </div>
              
//               <div className="product-metrics">
//                 <div className="metric">
//                   <span className="label">Revenue Contribution</span>
//                   <span className="value">{parseFloat(product.revenue_contribution).toFixed(1)}%</span>
//                 </div>
//                 <div className="metric">
//                   <span className="label">Trend</span>
//                   <span className={`trend-indicator trend-${product.trend}`}>
//                     {product.trend === 'up' ? '↑' : product.trend === 'down' ? '↓' : '→'}
//                     {' '}{product.trend_display}
//                   </span>
//                 </div>
//               </div>
              
//               {hasFeature('predictive_recommendations') && product.recommended_reorder_level && (
//                 <div className="recommendation">
//                   <span className="label">💡 Recommended Reorder:</span>
//                   <span className="value">{product.recommended_reorder_level} units</span>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Customer Insights Section */}
//       {hasFeature('customer_segments') ? (
//         <div className="analytics-section">
//           <div className="section-header">
//             <h2>Customer Segmentation</h2>
//             <button onClick={() => window.location.href = '/analytics/customers'} className="btn-link">
//               View All →
//             </button>
//           </div>

//           <div className="segment-stats">
//             <div className="segment-stat vip">
//               <Users size={20} />
//               <div>
//                 <span className="segment-count">{summary?.vip_customers || 0}</span>
//                 <span className="segment-label">VIP Customers</span>
//               </div>
//             </div>
//             <div className="segment-stat loyal">
//               <Users size={20} />
//               <div>
//                 <span className="segment-count">{summary?.loyal_customers || 0}</span>
//                 <span className="segment-label">Loyal Customers</span>
//               </div>
//             </div>
//             <div className="segment-stat at-risk">
//               <AlertTriangle size={20} />
//               <div>
//                 <span className="segment-count">{summary?.at_risk_customers || 0}</span>
//                 <span className="segment-label">At Risk</span>
//               </div>
//             </div>
//             <div className="segment-stat inactive">
//               <Users size={20} />
//               <div>
//                 <span className="segment-count">{summary?.inactive_customers || 0}</span>
//                 <span className="segment-label">Inactive</span>
//               </div>
//             </div>
//           </div>

//           {hasFeature('advanced_charts') && (
//             <SegmentationChart data={summary} />
//           )}
//         </div>
//       ) : (
//         <div className="analytics-section locked">
//           <div className="section-header">
//             <h2>Customer Segmentation</h2>
//             <span className="lock-badge">🔒 Business Plan</span>
//           </div>
//           <UpgradePrompt 
//             feature="customer_segments"
//             message="Upgrade to Business plan to unlock RFM analysis and customer segmentation"
//           />
//         </div>
//       )}

//       {/* Anomaly Alerts Section */}
//       {hasFeature('anomaly_detection') ? (
//         <div className="analytics-section">
//           <div className="section-header">
//             <h2>Anomaly Alerts</h2>
//             <button onClick={() => window.location.href = '/analytics/anomalies'} className="btn-link">
//               View All →
//             </button>
//           </div>

//           <div className="alerts-preview">
//             <p>Unusual patterns detected: {summary?.new_alerts || 0} new alerts</p>
//             <button className="btn-secondary">Review Alerts</button>
//           </div>
//         </div>
//       ) : (
//         <div className="analytics-section locked">
//           <div className="section-header">
//             <h2>Anomaly Detection</h2>
//             <span className="lock-badge">🔒 Business Plan</span>
//           </div>
//           <UpgradePrompt 
//             feature="anomaly_detection"
//             message="Get real-time alerts for unusual stock movements and sales patterns"
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// export default AnalyticsDashboard;



import React, { useState, useEffect } from 'react';
import { TrendingUp, Users, Package, AlertTriangle, Crown, RefreshCw } from 'lucide-react';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';
import apiClient from '../../api/client';
import ABCChart from './Charts/ABCDistributionChart';
import TrendLineChart from './Charts/TrendLineChart';
import SegmentationChart from './Charts/SegmentationChart';
import UpgradePrompt from '../subscription/UpgradePrompt';
import './AnalyticsDashboard.css';

function AnalyticsDashboard() {
  const { hasFeature, getPlanName, loading: featureLoading } = useFeatureAccess();
  const [summary, setSummary]         = useState(null);
  const [loading, setLoading]         = useState(true);
  const [refreshing, setRefreshing]   = useState(false);
  const [refreshMessage, setRefreshMessage] = useState(null);

  useEffect(() => { loadAnalyticsSummary(); }, []);

  async function loadAnalyticsSummary() {
    try {
      const response = await apiClient.get('/analytics/summary/');
      setSummary(response.data);
    } catch (error) {
      console.error('Failed to load analytics:', error);
    }
    setLoading(false);
  }

  async function handleRefresh() {
    setRefreshing(true);
    setRefreshMessage(null);
    try {
      await apiClient.post('/analytics/refresh/');
      await loadAnalyticsSummary();
      setRefreshMessage({ type: 'success', text: 'Analytics updated successfully' });
    } catch (error) {
      console.error('Failed to refresh analytics:', error);
      setRefreshMessage({ type: 'error', text: 'Refresh failed — please try again' });
    }
    setRefreshing(false);
  }

  if (loading || featureLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading analytics...</p>
      </div>
    );
  }

  if (!hasFeature('analytics_dashboard')) {
    return (
      <div className="analytics-locked">
        <Crown size={48} />
        <h2>Analytics Dashboard</h2>
        <p>Upgrade to access AI-powered insights and analytics</p>
        <UpgradePrompt feature="analytics_dashboard" />
      </div>
    );
  }

  const hasData = summary && summary.total_products > 0;

  return (
    <div className="analytics-dashboard fade-in">

      {/* Header — purpose is business performance overview, not operational alerts */}
      <div className="analytics-header">
        <div>
          <h1>Analytics & Insights</h1>
          <p className="subtitle">How your business has been performing</p>
          {summary?.last_calculated && (
            <p className="last-calculated">
              Last updated: {new Date(summary.last_calculated).toLocaleString()}
            </p>
          )}
        </div>
        <div className="header-actions">
          <div className="plan-badge">
            <Crown size={16} />
            <span>{getPlanName().toUpperCase()} Plan</span>
          </div>
          <button
            className={`btn-refresh ${refreshing ? 'refreshing' : ''}`}
            onClick={handleRefresh}
            disabled={refreshing}
            title="Recalculate all analytics"
          >
            <RefreshCw size={16} className={refreshing ? 'spin' : ''} />
            {refreshing ? 'Calculating...' : 'Run Analytics'}
          </button>
        </div>
      </div>

      {refreshMessage && (
        <div className={`refresh-message refresh-${refreshMessage.type}`}>
          {refreshMessage.text}
        </div>
      )}

      {/* Empty state */}
      {!hasData ? (
        <div className="analytics-empty-state">
          <RefreshCw size={48} />
          <h2>No analytics data yet</h2>
          <p>
            Click <strong>Run Analytics</strong> above to calculate product performance,
            customer segments, and sales trends. This takes a few seconds.
          </p>
        </div>
      ) : (
        <>
          {/* Sales Trend — only chart that makes sense at summary level */}
          {hasFeature('advanced_charts') && (
            <div className="analytics-section">
              <div className="section-header">
                <h2>Sales over the last 30 days</h2>
                <p className="section-desc">Daily revenue from shipped and delivered orders</p>
              </div>
              <TrendLineChart data={summary} />
            </div>
          )}

          {/* Product breakdown — summary counts + chart, link to full detail */}
          <div className="analytics-section">
            <div className="section-header">
              <h2>Product performance</h2>
              <button onClick={() => window.location.href = '/analytics/products'} className="btn-link">
                See full product table →
              </button>
            </div>

            {/* Plain-language summary — no jargon */}
            <div className="classification-stats">
              <div className="class-stat class-a">
                <span className="class-count">{summary?.class_a_products || 0}</span>
                <span className="class-label">⭐ Top sellers</span>
                <span className="class-desc">Driving ~80% of revenue</span>
              </div>
              <div className="class-stat class-b">
                <span className="class-count">{summary?.class_b_products || 0}</span>
                <span className="class-label">📦 Mid-range</span>
                <span className="class-desc">Solid contributors</span>
              </div>
              <div className="class-stat class-c">
                <span className="class-count">{summary?.class_c_products || 0}</span>
                <span className="class-label">🔹 Slow movers</span>
                <span className="class-desc">Worth reviewing</span>
              </div>
              <div className="class-stat trend-up-stat">
                <span className="class-count">{summary?.trending_up || 0}</span>
                <span className="class-label">📈 Growing</span>
                <span className="class-desc">Selling more than last month</span>
              </div>
            </div>

            {hasFeature('advanced_charts') ? (
              <ABCChart data={summary} />
            ) : (
              <UpgradePrompt
                feature="advanced_charts"
                message="Upgrade to Business plan for visual charts"
              />
            )}
          </div>

          {/* Customer breakdown — summary counts + chart, link to full detail */}
          {hasFeature('customer_segments') ? (
            <div className="analytics-section">
              <div className="section-header">
                <h2>Customer breakdown</h2>
                <button onClick={() => window.location.href = '/analytics/customers'} className="btn-link">
                  See full customer table →
                </button>
              </div>

              <div className="segment-stats">
                <div className="segment-stat vip">
                  <span className="segment-count">{summary?.vip_customers || 0}</span>
                  <span className="segment-label">🏆 VIP customers</span>
                </div>
                <div className="segment-stat loyal">
                  <span className="segment-count">{summary?.loyal_customers || 0}</span>
                  <span className="segment-label">🟢 Regular buyers</span>
                </div>
                <div className="segment-stat potential">
                  <span className="segment-count">{summary?.potential_customers || 0}</span>
                  <span className="segment-label">🔵 Growing</span>
                </div>
                <div className="segment-stat at-risk">
                  <span className="segment-count">{summary?.at_risk_customers || 0}</span>
                  <span className="segment-label">🟡 At risk of leaving</span>
                </div>
                <div className="segment-stat inactive">
                  <span className="segment-count">{summary?.inactive_customers || 0}</span>
                  <span className="segment-label">🔴 Lost customers</span>
                </div>
              </div>

              {hasFeature('advanced_charts') && (
                <SegmentationChart data={summary} />
              )}
            </div>
          ) : (
            <div className="analytics-section locked">
              <div className="section-header">
                <h2>Customer breakdown</h2>
                <span className="lock-badge">🔒 Business Plan</span>
              </div>
              <UpgradePrompt
                feature="customer_segments"
                message="Upgrade to Business plan to see how your customers are segmented"
              />
            </div>
          )}

          {/* Anomaly alerts — only if feature unlocked */}
          {hasFeature('anomaly_detection') ? (
            <div className="analytics-section">
              <div className="section-header">
                <h2>Unusual activity</h2>
                <button onClick={() => window.location.href = '/analytics/anomalies'} className="btn-link">
                  Review all →
                </button>
              </div>
              <div className="alerts-preview">
                {summary?.new_alerts > 0
                  ? <p>⚠️ <strong>{summary.new_alerts}</strong> unusual pattern{summary.new_alerts !== 1 ? 's' : ''} detected in stock or sales</p>
                  : <p>✅ No unusual activity detected</p>
                }
                <button
                  className="btn-secondary"
                  onClick={() => window.location.href = '/analytics/anomalies'}
                >
                  Review Alerts
                </button>
              </div>
            </div>
          ) : (
            <div className="analytics-section locked">
              <div className="section-header">
                <h2>Unusual activity detection</h2>
                <span className="lock-badge">🔒 Business Plan</span>
              </div>
              <UpgradePrompt
                feature="anomaly_detection"
                message="Get alerts when stock or sales move in unexpected ways"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AnalyticsDashboard;